import { z } from 'zod';
import { dateTimeSchema } from './common';

/** GET /api/health — public. Per-component status; never crashes on a failing dependency. */

export const componentStatusSchema = z.enum(['ok', 'degraded', 'error', 'skipped']);
export type ComponentStatus = z.infer<typeof componentStatusSchema>;

export const healthComponentSchema = z.object({
  status: componentStatusSchema,
  latencyMs: z.number().int().min(0).nullable(),
  message: z.string().nullable(),
  checkedAt: dateTimeSchema,
});
export type HealthComponent = z.infer<typeof healthComponentSchema>;

/**
 * `version` / `env` and every `components.*.message` are internal detail: they are
 * populated for an authenticated operator and null for anonymous callers, so a public
 * probe never leaks the bucket prefix, the database host or an upstream error string.
 */
export const healthResponseSchema = z.object({
  status: componentStatusSchema,
  version: z.string().nullable(),
  env: z.string().nullable(),
  uptimeSeconds: z.number().int().min(0),
  checkedAt: dateTimeSchema,
  components: z.object({
    db: healthComponentSchema,
    elevenlabs: healthComponentSchema,
    gcs: healthComponentSchema,
    worker: healthComponentSchema,
  }),
});
export type HealthResponse = z.infer<typeof healthResponseSchema>;
